import rill from "rill";
import redirect from "@rill/redirect";
import Support from "./support";
import Videos from "./videos";
import Downloads from "./downloads";
import Articles from "./articles";
import Faq from "./faq";
import Contact from "./contact";

const SupportController = (app) => {
  app
    .get("/support", redirect("/dashboard/support/contact"))
    .at(
      "/support/*",
      rill()
        .setup(Support)
        .setup(Videos)
        .setup(Downloads)
        .setup(Articles)
        .setup(Faq)
        .setup(Contact)
    );
};

export default SupportController;
